import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library

import Breadcrumb from '../components/Breadcrumb'
import DeveloperStartsFrom from '../components/DeveloperStartsFrom';
import NewsSec from '../sections/news/NewsSec';
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import CustomHelmet from '../components/CustomHelmet';
import { t } from 'i18next';
import FullScreenLoader from '../components/FullScreenLoader';
import NotFoundSec from "../sections/pageNotFound/NotFoundSec";
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';


const News = () => {

    const [newsSection, setNewsSection] = useState({
        items: [],
        totalPages: 1,
        pageIndex: 1,
    });

    const countryPrefix = useCountryPrefix();
    const { i18n } = useTranslation();

    const [pageIndex, setPageIndex] = useState(1);
    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadError, setLoadError] = useState(false);

    let apiUrl = process.env.REACT_APP_API_URL;


    const fetchData = async (page) => {

        apiUrl = `${apiUrl}${constants.newspagelist}?language=${language}&region_id=${countryPrefix}&PageIndex=${page}&PageSize=5`;
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {
            setNewsSection((prevData) => ({
                ...res.data,
                items: [...(prevData?.items || []), ...res.data.items]
            }));
            setIsLoaded(true)
            setLoadingMore(false)
        } else {
            setLoadError(true); // set error flag
            setIsLoaded(true);
        }

    }

    const handleLoadMore = () => {
        setLoadingMore(true)
        setPageIndex(prev => prev + 1);
    };

    React.useEffect(() => {
        AOS.init();

        fetchData(pageIndex);
    }, [pageIndex]);

    // const pathName = ["Home", "Our News"];
    const pathLang = isArabic ? "/ar" : "";
    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("news") }
    ];

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }
    if (loadError) {
        return (
            <NotFoundSec title={t("opps")} desc={t("news_not_found")} img={"/assets/img/not-found.svg"} cssstyle={"p-0"} />)
    }
    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Breadcrumb pathName={pathName}>
            </Breadcrumb>
            {/* <DeveloperStartsFrom companyName={"Company Name"} location={"New Cairo, Egypt"} priceStart={"43,424,000"} ></DeveloperStartsFrom> */}
            <NewsSec data={newsSection} onLoadMore={handleLoadMore} loadingMore={loadingMore}></NewsSec>
        </>
    )
}

export default News